export const isLiveChatDisabled = () =>
    document.querySelector('#disableLiveChatFeatureFlag')?.dataset?.disablelivechatfeatureflag === 'true';
